import React, { FC } from 'react';
import styles from './splitConent.module.scss';

const SplitConent: FC = props => (
    <div className={styles.splitConent}>
        {props.children}
    </div>
)
export default SplitConent;
